// src/services/productSync.ts
// Category descriptor table (apiName ↔ IndexedDB store ↔ mapper), consumed by
// useProductManager and InboundModal to map backend categories to local stores.

import { STORE_NAMES } from '../utils/db';
import {
  mapToSparkPlug,
  mapToSensor,
  mapToIgnitionCoil,
  mapToSteeringClock,
  mapToWires,
} from '../utils/importMappers';

export interface SyncCategory {
  apiName:   string;
  storeName: (typeof STORE_NAMES)[keyof typeof STORE_NAMES];
  label:     string;
  mapper:    (row: Record<string, unknown>) => unknown;
  /**
   * When set, instead of clearing the whole store this sync removes only
   * items where `item.categoryName === partialKey`, then appends fresh data.
   * Used when multiple API categories share a single IndexedDB store.
   */
  partialKey?: string;
}

export const SYNC_CATEGORIES: SyncCategory[] = [
  {
    apiName:   'spark_plugs',
    storeName: STORE_NAMES.sparkPlugs,
    label:     'Свечи зажигания',
    mapper:    mapToSparkPlug,
  },
  {
    apiName:   'ignition_coils',
    storeName: STORE_NAMES.coils,
    label:     'Катушки зажигания',
    mapper:    mapToIgnitionCoil,
  },
  {
    apiName:   'crankshaft_sensors',
    storeName: STORE_NAMES.sensors,
    label:     'Датчики (Коленвал - Распредвал)',
    mapper:    mapToSensor,
    partialKey: 'crankshaft_sensors',
  },
  {
    apiName:   'camshaft_sensors',
    storeName: STORE_NAMES.sensors,
    label:     'Датчики (Разные)',
    mapper:    mapToSensor,
    partialKey: 'camshaft_sensors',
  },
  {
    apiName:   'airbag_cables',
    storeName: STORE_NAMES.steeringClocks,
    label:     'Рулевые шлейфы',
    mapper:    mapToSteeringClock,
  },
  {
    apiName:   'ignition_coil_mouthpieces',
    storeName: STORE_NAMES.wires,
    label:     'Провода/наконечники',
    mapper:    mapToWires,
  },
];

